import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { PROJECT_LIST } from '../../constants';
import { updateNotificationsToggle } from '../../store/slices/invitesSlice';

const ProjectSelectPopup = ({ show, onClose, row }) => {
  const dispatch = useDispatch();
  const [selectedProjects, setSelectedProjects] = useState([]);

  const projectOptions = PROJECT_LIST.map((proj) => ({
    label: proj.projectName,
    value: proj.projectId,
  }));

  useEffect(() => {
    const selectedIds = row?.attributes?.metadata?.["3"]?.firebaseProject || [];
    const initial = selectedIds
      .map((id) => {
        const match = PROJECT_LIST.find((proj) => proj.projectId === id);
        return match ? { label: match.projectName, value: match.projectId } : null;
      })
      .filter(Boolean);
    setSelectedProjects(initial);
  }, [row, show]);

  const handleUpdate = () => {
    const selectedIds = selectedProjects.map((p) => p.value);
    dispatch(
      updateNotificationsToggle({
        message: 'Status Updated.',
        payload: {
          id: row.attributes.id,
          type: 'user',
          attributes: {
            enableNotification: true,
            firebaseProject: selectedIds,
          },
        },
      })
    );
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Select Firebase Project</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label fw-bold">Choose one or more projects:</label>
          <Select
            options={projectOptions}
            value={selectedProjects}
            onChange={setSelectedProjects}
            isMulti
            placeholder="Select projects..."
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleUpdate}
          disabled={selectedProjects.length === 0}
        >
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProjectSelectPopup;
